export { default } from './DetailSection';
